
<template>
  <div class="pop-search-wrap">
    <div class="pop-search">
      <div class="find">
        <span id="find_msg"></span>
        <input id="find_fwtext" type="text" v-model="keyword" @keyup="fnFindjs($event)"/>
        <div class="btns">
          <i class="el-icon-arrow-up" type="button" @click="fnFindPrev()"></i>
          <i class="el-icon-arrow-down" id="find_btn" type="button" value="Find Next" @click="fnFindNext()"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import {FindShow, FindPrev, FindNext} from './js/find.js'

  export default {

    props: {
      vScope: {
        dom: ''
      }
    },
    data () {
      return {
        keyword: '',
        scope: {
          dom: '',
          msg: '已经是最后一个！',
          callback: this.fnVFindCallback
        }
      }
    },

    mounted () {
      this.init()
    },
    methods: {
      init () {
        Object.assign(this.scope, this.vScope)
      },
      // 搜索显示匹配项
      fnFindjs (ev) {
        if (ev.keyCode === 13 && this.keyword) {
          if (!this.vScope.dom) {
            this.vScope.dom = ''
          }

          FindShow(this.scope)
        } else if (ev.keyCode === 8 && !this.keyword) {
          FindShow(this.scope)
        }
      },
      // 向上搜索
      fnFindPrev () {
        if (!this.vScope.dom) {
          this.vScope.dom = ''
        }

        FindPrev(this.scope)
      },
      // 向下搜索
      fnFindNext () {
        if (!this.vScope.dom) {
          this.vScope.dom = ''
        }
        FindNext(this.scope)
      },

      // 搜索组件，提示框
      fnVFindCallback () {


      },


    }
  }
</script>

<style>
  @import 'css/find.css';
</style>
